import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgChevronRightSmall(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0474 7.05025C8.65688 7.44078 8.65688 8.07394 9.0474 8.46447L12.5829 12L9.0474 15.5355C8.65688 15.9261 8.65688 16.5592 9.0474 16.9497C9.43793 17.3403 10.0711 17.3403 10.4616 16.9497L14.7043 12.7071C15.0948 12.3166 15.0948 11.6834 14.7043 11.2929L10.4616 7.05025C10.0711 6.65973 9.43793 6.65973 9.0474 7.05025Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightSmall);

var ChevronRightSmallSolid = forwardRef((props, ref) => jsx(ForwardRef, Object.assign({
  ref: ref
}, props)));

export { ChevronRightSmallSolid as default };
